import { z } from "zod";

export const brazilPhoneSchema = z
  .string()
  .refine((val) => val === "" || /^\+55 \(\d{2}\) \d{4,5}-\d{4}$/.test(val), {
    message: "clients_validation_phone_invalid",
  })
  .optional()
  .describe("Brazilian phone number with country code: +55 (XX) XXXXX-XXXX");

/** The stored `+55 (11) 99999-8888` shown without its country code. */
export const displayBrazilPhone = (phone: string | null | undefined): string | undefined =>
  phone?.replace(/^\+55 /, "");

export const formatBrazilPhone = (raw: string): string => {
  const rawDigits = raw.replace(/\D/g, "");
  const digits = (
    raw.trim().startsWith("+55") || rawDigits.length > 11 ? rawDigits.replace(/^55/, "") : rawDigits
  ).slice(0, 11);

  if (digits.length === 0) return "";

  let result = "+55 (";

  if (digits.length <= 2) {
    return result + digits;
  }

  result += `${digits.slice(0, 2)}) `;

  const local = digits.slice(2);

  if (local.length <= 4) {
    return result + local;
  }

  if (digits.length === 11) {
    return result + `${local.slice(0, 5)}-${local.slice(5)}`;
  }

  if (local.length <= 8) {
    return result + `${local.slice(0, 4)}-${local.slice(4)}`;
  }

  return result + `${local.slice(0, 5)}-${local.slice(5)}`;
};
